import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 264 107",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M146.95 43.7347C148.625 43.7347 149.984 42.3763 149.984 40.7007C149.984 39.025 148.625 37.6667 146.95 37.6667C145.274 37.6667 143.916 39.025 143.916 40.7007C143.916 42.3763 145.274 43.7347 146.95 43.7347Z",
      fill: "var(--dt-color-foreground-muted)"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M127.538 43.0308C126.85 43.0308 125.667 43.6856 125.051 45.6954L125.05 45.6994L119.22 64.4973C118.832 65.7481 117.503 66.4475 116.253 66.0596C115.002 65.6717 114.302 64.3433 114.69 63.0925L120.517 44.3065C120.517 44.3051 120.518 44.3037 120.518 44.3023C121.466 41.2124 123.95 38.2886 127.538 38.2886C131.124 38.2886 133.604 41.206 134.554 44.2909C134.554 44.292 134.554 44.2899 134.554 44.2909L139.043 58.764C139.659 60.7681 140.841 61.4238 141.528 61.4238C143.213 61.4238 144.578 60.0585 144.578 58.3738V48.4672C144.578 47.1576 145.64 46.0961 146.949 46.0961C148.259 46.0961 149.321 47.1576 149.321 48.4672V58.3738C149.321 62.6775 145.832 66.166 141.528 66.166C137.946 66.166 135.462 63.2495 134.512 60.1636C134.512 60.1625 134.513 60.1646 134.512 60.1636L130.023 45.6906C129.407 43.6856 128.227 43.0308 127.538 43.0308Z",
      fill: "var(--dt-color-foreground-muted)"
    }, null, -1)
  ]))]))
}
export default { render: render }